// 객실 마스터. 예약현황 달력 / 관리자 화면이 공통으로 사용합니다.
// 객실을 추가·삭제할 경우 여기와 DB(PENSION_RESERVATION.ROOM)만 맞춰주면 됩니다.
export const ROOMS = [
    { key: '단풍',   standard: '2인 기준', color: '#e57373' },
    { key: '보리수', standard: '2인 기준', color: '#ba68c8' },
    { key: '이팝',   standard: '4인 기준', color: '#64b5f6' },
    { key: '소나무', standard: '4인 기준', color: '#4db6ac' },
    { key: '느릅',   standard: '6인 기준', color: '#ffb74d' },
    { key: '자귀',   standard: '8인 기준', color: '#a1887f' },
];

export const ROOM_KEYS = ROOMS.map(r => r.key);

export const RESERVATION_STATUS = [
    { key: 'CONFIRMED', label: '예약확정' },
    { key: 'PENDING',   label: '입금대기' },
    { key: 'CANCELED',  label: '취소'    },
];